import { useEffect } from "react";

type MetaOptions = {
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  ogImage?: string;
};

const SITE_NAME = "91吃瓜网";

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  if (!content) return;
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  if (!href) return;
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function usePageMeta(title: string, options: MetaOptions = {}) {
  useEffect(() => {
    const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
    document.title = fullTitle;
    setMeta("name", "description", options.description ?? "");
    setMeta("name", "keywords", options.keywords ?? "");
    setMeta("name", "robots", "index,follow,max-image-preview:large");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", options.description ?? "");
    setMeta("property", "og:type", options.ogType ?? "website");
    setMeta("property", "og:locale", "zh_CN");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", options.description ?? "");

    const base = `https://microtransport.cn`;
    const canonical = `${base}${options.canonicalPath ?? "/"}`;
    setLink("canonical", canonical);
    setMeta("property", "og:url", canonical);
    if (options.ogImage) {
      setMeta("property", "og:image", options.ogImage);
      setMeta("name", "twitter:image", options.ogImage);
    }
  }, [title, options.description, options.keywords, options.canonicalPath, options.ogType, options.ogImage]);
}